import React from 'react'
import SendMailResetPassword from 'src/containers/Auth/SendMailResetPassword'

const SendMailResetPasswordPage: React.FC = () => {
  return <SendMailResetPassword></SendMailResetPassword>
}

export const PATH = '/pwd/reset' as const
export default SendMailResetPasswordPage
